import { defineComponent as _defineComponent } from 'vue'
import { ref, shallowRef } from 'vue'
import { ILeftTab } from '@/layout/type'
import LeftTabs from '@/layout/LeftTabsLayout.vue'
import OcrList from './OcrList.vue'
import OcrText from './OcrText.vue'
import OcrCard from './OcrCard.vue'
import { OCR } from '@/api/ocr/type'
import { tabNames } from './type'
import _ from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const activeName= ref<tabNames>('textOCR')
const tabs: ILeftTab[] = [
  {
    name: 'textOCR',
    icon: 'icon_ocr_text2',
    label: '文本识别',
  },
  {
    name: 'cardOCR',
    icon: 'icon_ocr_card2',
    label: '模板识别',
  },
  {
    name: 'listOCR',
    icon: 'icon_result_list',
    label: '结果列表',
    hiddenBackground: true
  },
]
function handleChangeTab (name: tabNames) {
  activeName.value = name
}
// 试用额度 最大次数
const limitCount = 100
const updateList = ref<OCR.OCRListRes[]>([])
const leftTabsRef = shallowRef<InstanceType<typeof LeftTabs>>()
function handleSetTab(tabKey: string) {
  leftTabsRef.value?.setTab(tabKey)
}

return { __sfc: true,activeName, tabs, handleChangeTab, limitCount, updateList, leftTabsRef, handleSetTab, LeftTabs, OcrList, OcrText, OcrCard }
}

})